import { TriangleAlertIcon } from 'lucide-react'

import type { Finding } from '@/modules/tools/bankruptcy/stores/types'
import { humanizeText } from '@/utils'
import { SourceTrigger } from './SourceTrigger'

export const FindingsReport = ({ findings }: { findings: Finding[] }) => {
  if (findings.length === 0) {
    return (
      <p className="text-muted-foreground text-sm">
        No consistency or avoidance findings.
      </p>
    )
  }

  return (
    <ul className="divide-y">
      {findings.map((finding, index) => {
        const category = humanizeText(finding.code)
        const title = finding.summary ?? category

        return (
          <li
            key={`${finding.code}-${finding.form}-${index}`}
            className="flex items-start gap-2 py-2.5 first:pt-0 last:pb-0"
          >
            <TriangleAlertIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
            <SourceTrigger
              source={finding.source}
              label={title}
              className="w-full items-start gap-2 text-left"
              iconClassName="mt-1.5 size-3.5"
            >
              <span className="block min-w-0 flex-1">
                <span className="block text-sm">{title}</span>
                <span className="block text-muted-foreground text-xs">
                  {finding.summary ? `${category} · ` : ''}
                  Form {finding.form}
                </span>
              </span>
              {finding.source && (
                <span className="shrink-0 rounded border px-1.5 py-0.5 text-muted-foreground text-xs tabular-nums">
                  p. {finding.source.page + 1}
                </span>
              )}
            </SourceTrigger>
          </li>
        )
      })}
    </ul>
  )
}
